module.exports = __webpack_public_path__ + "fa-solid-900.ttf?ff8d9f8adb0d09f11d4816a152672f53";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fortawesome/fontawesome-free/webfonts/fa-solid-900.ttf
// module id = 221
// module chunks = 0